import type { PlayerDto } from '@/types/dtos/player/response/player.dto';

/** Remote speaker consoles of the section on air (the ones the on-stage toggle brings in). */
export function remoteSpeakersForSection(
  players: PlayerDto[] | undefined,
  activeSlotId: string | undefined,
): PlayerDto[] {
  if (!activeSlotId || !Array.isArray(players)) {
    return [];
  }
  return players.filter(
    (player) =>
      player.type === 'remoteSpeakerPlayer' && player.isConnected && player.speakerSlotIds?.includes(activeSlotId),
  );
}

export function remoteSpeakerItemId(player: Pick<PlayerDto, 'id'>): string {
  return `remoteSpeaker:${player.id}`;
}
